import {create} from "zustand"
import {BookCommon, IBookPreview, IFetchBooksResult} from "../models/Book";
import {GET_BOOKS_URL} from "../utilities/API";
import useAlertStore from "./alertStore";

interface ICashBookState {
    books:BookCommon[],
    totalCount:number
}

interface IBooksState{
    totalCount:number
    books: BookCommon[],
    bookPageInfo: IBookPreview | null,
    isLoading:boolean,
    error:string | null,
    cash:Map<string,ICashBookState>,
    getBooksPreview: (offset?:number | null,limit?:number | null,search?:string | null,idKeyWords?:string | null, author?:string | null, place?:string | null,
                      yearFrom?:number | null, yearTo?:number | null, year?:number| null, type?:number | null, subType?:number | null,
                      signal?:AbortSignal) => void
}

const useBookListStore = create<IBooksState>((set,get)=>(
    {
        totalCount:0,
        books: [],
        bookPageInfo: null,
        isLoading:false,
        error: null,
        cash:new Map<string, ICashBookState>(),

        getBooksPreview : async (offset?:number | null,limit?:number | null,search?:string | null,idKeyWords?:string | null, author?:string | null, place?:string | null,
                                 yearFrom?:number | null, yearTo?:number | null, year?:number| null, type?:number | null, subType?:number | null,
                                 signal?:AbortSignal) =>{
            set({isLoading: true,error:null});
            let offsetParam = offset ? `offset=${offset}` : 'offset=0';
            let limitParam = limit ? `&limit=${limit}` : '&limit=5';

            let searchParam = search ? `&query=${search}` : '';
            let idKeyWordsParam = idKeyWords ? `&idkeywords=${idKeyWords}` : '';
            let authorNameParam = author ? `&authorname=${author}` : '';
            let yearFromParam = yearFrom ? `&yearfrom=${yearFrom}` : '';
            let yearToParam = yearTo ? `&yearto=${yearTo}` : '';
            let placeParam = place ? `&place=${place}` : '';
            let yearParam = year ? `&year=${year}` : '';
            let typeParam = type ? `&type=${type}` : '';
            let subTypeParam = subType ? `&subtype=${subType}` : '';
            let isAborted = false;

            let paramsString = `${offsetParam}${limitParam}${idKeyWordsParam}${searchParam}${authorNameParam}${yearFromParam}
                                                     ${yearToParam}${yearParam}${typeParam}${placeParam}${subTypeParam}`;

            const Url = GET_BOOKS_URL+`?${paramsString}`
            let cash = useBookListStore.getState().cash.get(Url)
            if(cash && cash.books.length > 0)
            {
                set({books: cash.books,totalCount:cash.totalCount, isLoading:false});
                return;
            }

            try{
                console.log(Url);
                await fetch(Url,{signal:signal,credentials:"same-origin"}).then(async (response)=>{
                    let result = await response.json() as IFetchBooksResult;
                    if(result.success === false)
                        throw new Error("При получении даннхы проишла ошибка!");
                    console.log(result);
                    set({books:result.data.books, totalCount:result.data.count});
                    useBookListStore.getState().cash.set(Url,{books:result.data.books,totalCount:result.data.count})
                }).catch((e)=>{
                    if(e.message === "The user aborted a request.")
                    {
                        isAborted = true
                    }
                    else
                    {
                        set({error: "Не удалось загрузить данные"})
                        useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось загрузить данные по книгам"},20000)
                    }

                }).finally(()=>{
                    if(isAborted === false)
                    {
                        set({isLoading:false});
                    }
                })
            }
            catch (e) {
                set({error: "Не удалось выполнить запрос на получение данных"})
                useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось выполнить запрос на получение данных по книгам"},20000)
            }
        }
    }
))

export default useBookListStore;